import { AdobeRegistry } from '../types/AdobeAnalyticsDataLayer';

export const ADOBE_MAP: AdobeRegistry = {
    'event-eye-exam-$115-92004': { //event 8
        event: "eye-exam",
        eventInfo: {
            linkName: "eye-exam",
            linkType: "other"
        },
        selection: {
            flow: {
                name: "eye-exam-flow"
            },
            eyeExams: 1
        },
    },
    'event-vision-products': { //event 9
        event: "vision-products",
        eventInfo: {
            linkName: "vision-products",
            linkType: "other"
        },
        selection: {
            flow: {
                name: "vision-products-flow"
            },
            visionProducts: 1
        },
    },
    'event-glasses': { //event 10
        event: "glasses",
        eventInfo: {
            linkName: "glasses",
            linkType: "other"
        },
        selection: {
            flow: {
                name: "glasses-flow"
            },
            glasses: 1,
            subType: "glasses"
        },
    },
    'event-contacts': { //event 11
        event: "contacts",
        eventInfo: {
            linkName: "contacts",
            linkType: "other"
        },
        selection: {
            flow: {
                name: "contacts-flow"
            },
            contacts: {
                all: 1
            },
            subType: "contacts"
        },
    },
    'event-basic-frame-$110-v2020': { //event 12
        event: "frame-basic",
        eventInfo: {
            linkName: "frame-basic",
            linkType: "other"
        },
        selection: {
            frame: {
                basic: 1
            }
        },
    },
    'event-standard-frame-$160-v2020': { //event 13
        event: "frame-standard",
        eventInfo: {
            linkName: "frame-standard",
            linkType: "other"
        },
        selection: {
            frame: {
                standard: 1
            }

        },
    },
    'event-luxury-frame-$320-v2020': { //event 14
        event: "frame-luxury",
        eventInfo: {
            linkName: "frame-luxury",
            linkType: "other"
        },
        selection: {
            frame: {
                luxury: 1
            }

        },

    },
    'event-premium-frame-$220-v2020': { //event 15
        event: "frame-premium",
        eventInfo: {
            linkName: "frame-premium",
            linkType: "other"
        },
        selection: {
            frame: {
                premium: 1
            }

        },

    },
    'event-single-vision-lens-$90-v2100': { //event 16
        event: "lens-single-vision",
        eventInfo: {
            linkName: "lens-single-vision",
            linkType: "other"
        },
        selection: {
            lens: {
                singleVision: 1
            },
            lensType: "single-vision"
        },
    },
    'event-lined-bifocal-lens-$135-v2200': { //event 17
        event: "lens-bifocal",
        eventInfo: {
            linkName: "lens-bifocal",
            linkType: "other"
        },
        selection: {
            lens: {
                linedBifocal: 1
            },

            lensType: "lined-bifocal"

        },
    },
    'event-progressive-standard-lens-$160-v2781': { //event 18
        event: "lens-progressive-standard",
        eventInfo: {
            linkName: "lens-progressive-standard",
            linkType: "other"
        },
        selection: {
            lens: {
                progressiveStandard: 1
            },
            lensType: "progressive"

        },
    },
    'event-lens-material-plastic': { //event 19
        event: "lens-material-plastic",
        eventInfo: {
            linkName: "lens-material-plastic",
            linkType: "other"
        },
        selection: {
            lens: {
                material: {
                    plastic: 1
                }
            },

            material: "plastic"

        },
    },
    'event-polycarbonate-lens-$110-v2784': { //event 20
        event: "lens-material-polycarbonate",
        eventInfo: {
            linkName: "lens-material-polycarbonate",
            linkType: "other"
        },
        selection: {
            lens: {
                material: {
                    polycarbonate: 1
                }
            },

            material: "polycarbonate"

        },
    },
    'event-high-index-lens-$145-v2783': { //event 21
        event: "lens-material-high-index",
        eventInfo: {
            linkName: "lens-material-high-index",
            linkType: "other"
        },
        selection: {
            lens: {
                material: {
                    highIndex: 1
                }
            },

            material: "high-index"

        },
    },
    'event-lens-options-none': { // event 22
        event: "lens-option-none",
        eventInfo: {
            linkName: "lens-option-none",
            linkType: "other"
        },
        selection: {
            lens: {
                option: {
                    none: 1

                }
            },

            option: "none"

        },
    },
    'event-scratch-resistant-lens-$20-v2760': { //event 23
        event: "lens-option-scratch-resistant",
        eventInfo: {
            linkName: "lens-option-scratch-resistant",
            linkType: "other"
        },
        selection: {
            lens: {
                option: {
                    scratchResistant: 1
                }
            },

            option: "scratch-resistant"

        },
    },
    'event-photochromic-lens-$120-v2744': { //event 24
        event: "lens-option-photochromic",
        eventInfo: {
            linkName: "lens-option-photochromic",
            linkType: "other"
        },
        selection: {
            lens: {
                option: {
                    photochromic: 1
                }
            },

            option: "photochromic"

        },
    },
    'event-ultra-violet-uv-$20-v2755': { //event 25
        event: "lens-option-uv",
        eventInfo: {
            linkName: "lens-option-uv",
            linkType: "other"
        },
        selection: {
            lens: {
                option: {
                    ultraviolet: 1
                }
            },

            option: "uv-protection"

        },
    },
    'event-conventional-contacts-$150-v2520': { //event 26
        event: "contacts-conventional",
        eventInfo: {
            linkName: "contacts-conventional",
            linkType: "other"
        },
        selection: {
            contacts: {
                conventional: 1
            },

            type: "conventional"
        },
    },
    'event-add-eye-exam-yes': { //event 27
        event: "add-eye-exam-yes",
        eventInfo: {
            linkName: "add-eye-exam-yes",
            linkType: "other"
        },
        selection: {
            eyeExam: {
                add: {
                    yes: 1
                }
            },

            subType: "eye-exam",
            response: "yes"
        },
    },
    'event-add-eye-exam-no': { //event 28
        event: "add-eye-exam-no",
        eventInfo: {
            linkName: "add-eye-exam-no",
            linkType: "other"
        },
        selection: {
            eyeExam: {
                add: {
                    no: 1
                }
            },

            subType: "eye-exam",
            response: "no"
        },
    },
    'event-progressive-tier-1-lens-$200-v2781tg': { //event 29
        event: "lens-progressive-tier1",
        eventInfo: {
            linkName: "lens-progressive-tier1",
            linkType: "other"
        },
        selection: {
            lens: {
                progressiveTier1: 1
            },

            lensType: "progressive"
        },
    },
    'event-progressive-tier-2-lens-$250-v278122': { //event 30
        event: "lens-progressive-tier2",
        eventInfo: {
            linkName: "lens-progressive-tier2",
            linkType: "other"
        },
        selection: {
            lens: {
                progressiveTier2: 1
            },

            lensType: "progressive"

        },
    },
    'event-progressive-tier-3-lens-$250-v278125': { //event 31
        event: "lens-progressive-tier3",
        eventInfo: {
            linkName: "lens-progressive-tier3",
            linkType: "other"
        },
        selection: {
            lens: {
                progressiveTier3: 1
            },

            lensType: "progressive"


        },
    },
    'event-a/r-standard-lens-$70-v2750': { //event 32
        event: "lens-option-ar-standard",
        eventInfo: {
            linkName: "lens-option-ar-standard",
            linkType: "other"
        },
        selection: {
            lens: {
                option: {
                    arStandard: 1
                }
            },

            option: "anti-reflective"

        },
    },
    'event-a/r-tier-1-lens-$100-v275022': { //event 33
        event: "lens-option-ar-tier1",
        eventInfo: {
            linkName: "lens-option-ar-tier1",
            linkType: "other"
        },
        selection: {
            lens: {
                option: {
                    arTier1: 1
                }
            },

            option: "anti-reflective"

        },
    },
    'event-a/r-tier-2-lens-$120-v275025': { //event 34
        event: "lens-option-ar-tier2",
        eventInfo: {
            linkName: "lens-option-ar-tier2",
            linkType: "other"
        },
        selection: {
            lens: {
                option: {
                    arTier2: 1
                }
            },

            option: "anti-reflective"

        },
    }
    ,
    'event-disposable-contacts-daily-6-month-supply-$300-s0512': { //event 35
        event: "contacts-daily-6mo",
        eventInfo: {
            linkName: "contacts-daily-6mo",
            linkType: "other"
        },
        selection: {
            contacts: {
                disposable: {
                    daily6Month: 1
                }
            },

            type: "disposable",
            frequency: "daily",
            supply: "6-month"

        },
    },
    'event-disposable-contacts-daily-12-month-supply-$600-s0512': { //event 36
        event: "contacts-daily-12mo",
        eventInfo: {
            linkName: "contacts-daily-12mo",
            linkType: "other"
        },
        selection: {
            contacts: {
                disposable: {
                    daily12Month: 1
                }
            },

            type: "disposable",
            frequency: "daily",
            supply: "12-month"

        },
    },
    'event-disposable-contacts-bi-weekly-6-month-supply-$137.50-s0500': { //event 37
        event: "contacts-biweekly-6mo",
        eventInfo: {
            linkName: "contacts-biweekly-6mo",

            linkType: "other"
        },
        selection: {
            contacts: {
                disposable: {
                    biWeekly6Month: 1
                }
            },

            type: "disposable",
            frequency: "bi-weekly",
            supply: "6-month"

        },
    },
    'event-disposables-contacts-bi-weekly-12-month-supply-$275-s0500': { //event 38
        event: "contacts-biweekly-12mo",
        eventInfo: {
            linkName: "contacts-biweekly-12mo",
            linkType: "other"
        },
        selection: {
            contacts: {
                disposable: {
                    biWeekly12Month: 1
                }
            },

            type: "disposable",
            frequency: "bi-weekly",

            supply: "12-month"

        },
    },
    'event-disposable-contacts-monthly-6-month-supply-$120-s0500': { //event 39
        event: "contacts-monthly-6mo",
        eventInfo: {
            linkName: "contacts-monthly-6mo",
            linkType: "other"
        },
        selection: {
            contacts: {
                disposable: {
                    monthly6Month: 1
                }
            },

            type: "disposable",
            frequency: "monthly",
            supply: "6-month"

        },
    },
    'event-disposable-contacts-monthly-12-months-$240-s0500': { //event 40
        event: "contacts-monthly-12mo",
        eventInfo: {
            linkName: "contacts-monthly-12mo",
            linkType: "other"
        },
        selection: {
            contacts: {
                disposable: {
                    monthly12Month: 1
                }
            },

            type: "disposable",
            frequency: "monthly",
            supply: "12-month"

        },
    },
    'event-price-display': { //event 41
        event: "price-display",
        eventInfo: {
            linkName: "price-display",
            linkType: "other"
        },
        action: {
            priceDisplay: 1
        },
        user: {
            clientId: "CLIENT123",
            group: {
                identifier: "GROUP456"
            }
        },
        selection: {
            flow: {
                name: "glasses-flow" // From %Flow% data element
            }
        },
    },
    'event-restart': {
        event: "restart",
        eventInfo: {
            linkName: "restart",
            linkType: "other"
        },
        action: {
            restart: 1
        },
    }

};


